import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import InAppMessage from "./in-app-message.js";

var ModalMessage = /*#__PURE__*/function (_InAppMessage) {
  _inherits(ModalMessage, _InAppMessage);

  var _super = _createSuper(ModalMessage);

  function ModalMessage(e, t, r, s, n, l, o, u, a, p, d, i, m, c, f, g, x, j, v, A, T, b, h, k, q, w, y) {
    _classCallCheck(this, ModalMessage);

    return _super.call(this, e, t, null, r, s, n, l, o, u = u || InAppMessage.DismissType.MANUAL, a, p, d, i, m, c, f, g, x, j, v, A, T, b, h, k, q = q || InAppMessage.CropType.FIT_CENTER, void 0, w, y);
  }

  _createClass(ModalMessage, [{
    key: "ke",
    get: function get() {
      return InAppMessage.TextAlignment.CENTER;
    }
  }]);

  return ModalMessage;
}(InAppMessage);

export { ModalMessage as default };
ModalMessage.es = InAppMessage.es.zi;